import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Divider,
    TextField,
    Button,
    Modal,
    Box,
    ButtonGroup
} from '@mui/material';
import { ThreeDots } from 'react-loader-spinner';
import useProjects from '../../hooks/useProjects';
import SignatureLimitSection from './template-settings/SignatureLimitSection';
import CertificateUploadSection from './template-settings/CertificateUploadSection';
import QrUploadSection from './template-settings/QrUploadSection';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '90vw',
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
};

const TemplateSettings = ({ projectId, signatureLimit, setSignatureLimit, configureSignatureLimit, projectDetails, viewProjectDetails }) => {



    const [isConfiguringSignatureLimit, setIsConfiguringSignatureLimit] = useState(false);

    const [certTemplateFile, setCertTemplateFile] = useState(null);
    const [certPreviewUrl, setCertPreviewUrl] = useState('');
    const [isCertModalOpen, setIsCertModalOpen] = useState(false);

    const [qrLogoFile, setQrLogoFile] = useState(null);
    const [qrPreviewUrl, setQrPreviewUrl] = useState('');
    const [isQrLogoSaved, setIsQrLogoSaved] = useState(false);
    const [isQrModalOpen, setIsQrModalOpen] = useState(false);

    const [certBg, setCertBg] = useState(null);
    const [qrIcon, setQrIcon] = useState(null);

    // Signature Limit Handlers
    const handleOnChangeSignatureLimit = (e) => {
        const input = e.target.value;

        if (input < 0 || input === "") {
            setSignatureLimit(0);

        } else if (input > 10) {
            setSignatureLimit(10);

        } else {
            setSignatureLimit(input);
        }
    }


    const handleSaveSignatureLimit = (e) => {
        if (signatureLimit > 10) {
            let modifiedSignatureLimit = 10;

            configureSignatureLimit(projectId, modifiedSignatureLimit);

        } else {
            configureSignatureLimit(projectId, signatureLimit);
        }
    }

   

    

    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>

            <Grid item xs={12}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#0178f2', fontSize: 14 }}>
                    Template Settings
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Divider sx={{ color: 'blue' }} />
            </Grid>

            <SignatureLimitSection
                signatureLimit={signatureLimit}
                handleOnChangeSignatureLimit={handleOnChangeSignatureLimit}
                handleSaveSignatureLimit={handleSaveSignatureLimit}
                isConfiguringSignatureLimit={isConfiguringSignatureLimit}
            />

            <CertificateUploadSection
                projectDetails={projectDetails}
                certTemplateFile={certTemplateFile}
                certPreviewUrl={certPreviewUrl}
                setIsCertModalOpen={setIsCertModalOpen}
                projectId={projectId}
                setCertPreviewUrl={setCertPreviewUrl}
                setCertTemplateFile={setCertTemplateFile}
                setCertBg={setCertBg}
            />

            <QrUploadSection
                projectId={projectId}
                projectDetails={projectDetails}
                setIsQrModalOpen={setIsQrModalOpen}
                qrPreviewUrl={qrPreviewUrl}
                setQrPreviewUrl={setQrPreviewUrl}
                setQrIcon={setQrIcon}
            />


            {/* Certificate Modal */}
            <Modal
                open={isCertModalOpen}
                onClose={() => setIsCertModalOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{ invisible: true }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        outline: 'none',
                        borderRadius: 2,
                        maxWidth: '60vw',
                        maxHeight: '60vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Button
                        size="small"
                        onClick={() => setIsCertModalOpen(false)}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            minWidth: 'auto',
                            fontSize: 12,
                            zIndex: 1,
                            fontWeight: 'bold'
                        }}
                    >
                        ✕
                    </Button>

                    {(certBg || projectDetails?.cert_bg_url) && (
                        <img
                            src={projectDetails?.cert_bg_url || certBg}
                            alt="Certificate Preview"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '80vh',
                                objectFit: 'contain',
                                borderRadius: 0,
                                border: 'none',
                                imageRendering: 'pixelated',
                            }}
                        />
                    )}
                </Box>
            </Modal>


            {/* QR Code Modal */}
            <Modal
                open={isQrModalOpen}
                onClose={() => setIsQrModalOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{ invisible: true }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        outline: 'none',
                        borderRadius: 2,
                        maxWidth: 300,
                        maxHeight: 300,
                        width: '90vw',
                        height: '90vw',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Button
                        size="small"
                        onClick={() => setIsQrModalOpen(false)}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            minWidth: 'auto',
                            fontSize: 12,
                            zIndex: 1,
                            fontWeight: 'bold'
                        }}
                    >
                        ✕
                    </Button>

                    {(qrIcon || projectDetails?.qr_icon_url) && (
                        <img
                            src={projectDetails?.qr_icon_url || qrIcon}
                            alt="QR Code"
                            style={{
                                width: '50px',
                                height: '50px',
                                objectFit: 'contain',
                                borderRadius: 0,
                                border: 'none',
                                imageRendering: 'pixelated',
                            }}
                        />
                    )}
                </Box>
            </Modal>

        </Grid>
    );
};

export default TemplateSettings;
